import { useMemo } from 'react';
import { useIsDemo } from '@/hooks/common/useIsDemo';
import { useSelectedOrgId } from '@/hooks/common/useSelectedOrgId';
import {
  ALL_DELIVERY_ITEMS,
  DELIVERY_BALANCE,
  DELIVERY_CONNECTED_ACCOUNTS,
  DELIVERY_DETAIL_DATA,
  DELIVERY_EMPTY_DETAIL,
  DELIVERY_PARTIES,
  PERSONAL_ORG_ID,
} from '@/mockData';
import { filterByOrg } from '@/mockData/common/demoFilters';

export function useDeliveryManagerData() {
  const isDemo = useIsDemo();
  const selectedOrgId = useSelectedOrgId();
  const activeOrgId = selectedOrgId || PERSONAL_ORG_ID;

  const items = useMemo(
    () => (isDemo ? filterByOrg(ALL_DELIVERY_ITEMS, activeOrgId) : []),
    [activeOrgId, isDemo],
  );
  const detailData = useMemo(
    () => (isDemo ? DELIVERY_DETAIL_DATA[activeOrgId] ?? {} : {}),
    [activeOrgId, isDemo],
  );
  const connectedAccounts = useMemo(
    () => (isDemo ? DELIVERY_CONNECTED_ACCOUNTS[activeOrgId] ?? [] : []),
    [activeOrgId, isDemo],
  );
  const equaliqBalanceCents = useMemo(
    () => (isDemo ? DELIVERY_BALANCE[activeOrgId] ?? 0 : 0),
    [activeOrgId, isDemo],
  );
  const parties = useMemo(
    () => (isDemo ? DELIVERY_PARTIES[activeOrgId] ?? {} : {}),
    [activeOrgId, isDemo],
  );
  const emptyDetailData = useMemo(
    () => DELIVERY_EMPTY_DETAIL[activeOrgId] ?? DELIVERY_EMPTY_DETAIL[PERSONAL_ORG_ID],
    [activeOrgId],
  );

  return {
    items,
    detailData,
    connectedAccounts,
    equaliqBalanceCents,
    parties,
    emptyDetail: emptyDetailData,
  };
}
